import type { CSSProperties } from 'react';

interface LayerTransitionProps {
  visible: boolean;
  goingDeeper: boolean;
}

export function LayerTransition({ visible, goingDeeper }: LayerTransitionProps) {
  if (!visible) return null;

  const ringColor = goingDeeper ? 'rgba(139,92,246,0.7)' : 'rgba(251,191,36,0.7)';

  return (
    <div
      className="absolute inset-0 z-50 flex flex-col items-center justify-center overflow-hidden scanlines"
      style={{ background: 'radial-gradient(ellipse at center, #1e1b4b 0%, #000 70%)' }}
    >
      {/* Expanding rings */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
        {[0, 1, 2, 3, 4].map((i) => (
          <div
            key={i}
            className="layer-ring"
            style={{ '--ring-i': i, borderColor: ringColor } as CSSProperties}
          />
        ))}
      </div>

      {/* Direction arrow */}
      <div
        className={`relative z-10 text-6xl mb-4 select-none ${goingDeeper ? 'layer-dive-arrow' : 'layer-ascend-arrow'}`}
      >
        {goingDeeper ? '⬇' : '⬆'}
      </div>

      {/* Label */}
      <div className="relative z-10 text-white text-2xl font-bold tracking-widest font-mono">
        {goingDeeper ? 'DIVING IN...' : 'ASCENDING...'}
      </div>
    </div>
  );
}
